// extracted by mini-css-extract-plugin
module.exports = {"switch":"toggle_switch__RK67v","slider":"toggle_slider__Dp1uy","on":"toggle_on__YTuEG","off":"toggle_off__QcvKv","active":"toggle_active__MODom"};